<template>
  <div class="row">
    <div class="col-12">
      <button class="btn btn-sm btn-xml btn-block text-export"
              @click="getXML()">
        Exportar XML do registro
      </button>
    </div>
  </div>
</template>
<script>
  /* services */
  import RegistrosService from "@/services/Registros"

  export default {
    name: 'ExportarXML',
    props: {
      propRegistroId: {type: Number, default: null}
    },
    methods: {
      async getXML () {
        try {
          loader({text: 'Gerando XML', active: true})

          const res = await RegistrosService.gerarXML(this.propRegistroId)

          //window.open(url)
          let blob = new Blob([res.xml], { type: 'application/xml' })
          let url = window.URL.createObjectURL(blob)
          
          var a = document.createElement("a")
          document.body.appendChild(a)
          a.href = url
          a.download = res.fileName

          a.click()
          a.remove()
        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({text: '', active: false})
        }
      },
      displayError (title, text = '', html = '') {
        objSwal.error.title = title
        objSwal.error.text = text
        objSwal.error.html = html
        ,
        setTimeout(() => {
          const btnConfirm = document.querySelector('.swal2-confirm')

          if (btnConfirm) btnConfirm.focus()
        }, 300)

        return Swal.fire(objSwal.error).then((res) => {
          objSwal.error.title = ''
          objSwal.error.text = ''
          objSwal.error.html = ''

          return res
        })
      }
    }
  }
</script>
<style lang="scss">
  .btn-xml {
    background: #17a2b8 !important;
    border-color: #17a2b8;
    color: #000000 !important;
  }

  .btn-xml:hover {
    background: #17a2b8 !important;
    border-color: #17a2b8;
    color: #000000 !important;
  }

  .btn-xml:active {
    background: #17a2b8 !important;
    border-color: #17a2b8;
    color: #000000 !important;
  }

</style>
